import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { lazyShowCalendarNotification } from 'owa-calendar-notification-bar';
import type { ViewType } from 'owa-calendar-actions';
import { calendarNotificationsBarCreateEvent } from 'owa-locstrings/lib/strings/calendarNotificationsBarCreateEvent.locstring.json';
import { calendarNotificationsBarCreateDraftEvent } from 'owa-locstrings/lib/strings/draftcreatedevent.locstring.json';

export function onItemCreatedLocally(isDraft: boolean, actionSource: ViewType) {
    const message = isDraft
        ? loc(calendarNotificationsBarCreateDraftEvent)
        : loc(calendarNotificationsBarCreateEvent);

    lazyShowCalendarNotification.import().then(showCalendarNotification => {
        showCalendarNotification('instantCalendarEventCreate', actionSource, message, {
            icon: ControlIcons.CheckMark,
        });
    });
}
